namespace $ {
	
	$mol_wire_log.active()

}
